import { JourneyDraft, UpdateDraft } from '../../../draft';
import { mileCompleteSchema } from '../../../jsonSchemas';
import JsonField from '../JsonField/JsonField';
import PanelHeader from '../PanelHeader/PanelHeader';

interface MileCompletePanelProps {
  draft: JourneyDraft;
  mileIndex: number;
  update: UpdateDraft;
}

const MileCompletePanel = ({ draft, mileIndex, update }: MileCompletePanelProps) => {
  const mile = draft.miles[mileIndex];

  return (
    <div className="grid gap-6">
      <PanelHeader
        eyebrow={`Mile ${mileIndex + 1} · ${mile.title || 'Untitled mile'}`}
        title="Mile complete"
        icon={<span className="text-2xl">🏁</span>}
      />
      <p className="text-sm text-neutral-60">
        The screen that closes the mile, opened from the flag on the map after the mile’s last step:
        the author’s insight cards, each with a kicker, a title and a body.
      </p>
      <div className="grid gap-3">
        <h3 className="text-lg font-semibold text-neutral-90">Content (JSON)</h3>
        <JsonField
          key={mile.key}
          value={{ insights: mile.insights }}
          schema={mileCompleteSchema}
          onChange={({ insights }) => update((d) => void (d.miles[mileIndex].insights = insights))}
        />
      </div>
    </div>
  );
};

export default MileCompletePanel;
